import { useComponentConfig } from 'js/hooks/component';
import { useEffect } from 'react';

import { PRODUCTS } from '../constants';
import { useDynamicReducerDispatch } from '../store';
import * as actions from '../store/actions';

export const useInitProduct = () => {
    const { productCasino, productSportsbook } = useComponentConfig();
    const dispatch = useDynamicReducerDispatch();

    useEffect(() => {
        if (productCasino) {
            dispatch(actions.setProduct(PRODUCTS.CASINO));
        } else if (productSportsbook) {
            dispatch(actions.setProduct(PRODUCTS.SPORTSBOOK));
        }
    }, [
        dispatch,
        productCasino,
        productSportsbook
    ]);
};
